var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveLclIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75781 2V10.4851H16.243V2H13.5156V5.03041H10.4852V2H7.75781Z",
    fill: "#C5C9CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5156 13.5146V21.9998H22.0008V13.5146H19.2734V16.5451H16.243V13.5146H13.5156Z",
    fill: "#C5C9CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.5146V21.9998H10.4851V13.5146H7.75778V16.5451H4.72737V13.5146H2Z",
    fill: "#C5C9CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveLclIcon);
export default __webpack_public_path__ + "static/media/inactive-lcl-icon.12f9cf37d8e2ec938ef6e494b614a25e.svg";
export { ForwardRef as ReactComponent };